export const getNameCurrentElement = (state) => {
    return state.nameCurrentElement
}

export const getRouteParent = (state) => {
    return state.routeParent
}